export default __webpack_public_path__ + "static/media/acknowledged.d383823f.svg";